/*
Important: The data and text in this file are not covered by the GPL
Descriptions and some names are copyright and owned by Edge Studio, no copyright
claim is intended by application author(s)
*/
export interface ISkill {
    name: string;
    attribute: string;
    value: number;
    book: string;
    page: string;
    settings: string[];
}

export const SkillList: ISkill[] = [
    {
        name: "Alchemy",
        attribute: "intellect",
        value: 0,
        book: "Core",
        page: "57",
        settings: ["Fantasy", "steampunk", "Weird War"],
    },
    {
        name: "Arcana",
        attribute: "intellect",
        value: 0,
        book: "Core",
        page: "70",
        settings: [],
    },
    {
        name: "Astrocartography",
        attribute: "intellect",
        value: 0,
        book: "Core",
        page: "57",
        settings: ["Space Opera"],
    },
    {
        name: "Athletics",
        attribute: "brawn",
        value: 0,
        book: "Core",
        page: "58",
        settings: ["All"],
    },
    {
        name: "Brawl",
        attribute: "brawn",
        value: 0,
        book: "Core",
        page: "67",
        settings: ["All"],
    },
    {
        name: "Charm",
        attribute: "presence",
        value: 0,
        book: "Core",
        page: "54",
        settings: ["All"],
    },
    {
        name: "Coercion",
        attribute: "presence",
        value: 0,
        book: "Core",
        page: "55",
        settings: ["All"],
    },
    {
        name: "Computers",
        attribute: "intellect",
        value: 0,
        book: "Core",
        page: "55",
        settings: ["Modern Day", "Science Fiction", "space opera"],
    },
    {
        name: "Cool",
        attribute: "presence",
        value: 0,
        book: "Core",
        page: "59",
        settings: ["All"],
    },
    {
        name: "Coordination",
        attribute: "agility",
        value: 0,
        book: "Core",
        page: "59",
        settings: ["All"],
    },
    {
        name: "Deception",
        attribute: "cunning",
        value: 0,
        book: "Core",
        page: "56",
        settings: ["All"],
    },
    {
        name: "Discipline",
        attribute: "willpower",
        value: 0,
        book: "Core",
        page: "60",
        settings: ["All"],
    },
    {
        name: "Divine",
        attribute: "willpower",
        value: 0,
        book: "Core",
        page: "70",
        settings: ["All"],
    },
    {
        name: "Driving",
        attribute: "agility",
        value: 0,
        book: "Core",
        page: "60",
        settings: ["Steampunk", "Weird War", "Modern Day", "Science Fiction", "Space Opera"],
    },
    {
        name: "Gunnery",
        attribute: "intellect",
        value: 0,
        book: "Core",
        page: "69",
        settings: ["Steampunk", "Weird War", "Modern Day", "Science Fiction", "Space Opera"],
    },
    {
        name: "Knowledge",
        attribute: "intellect",
        value: 0,
        book: "Core",
        page: "66",
        settings: ["All"],
    },
    {
        name: "Leadership",
        attribute: "presence",
        value: 0,
        book: "Core",
        page: "56",
        settings: ["All"],
    },
    {
        name: "Mechanics",
        attribute: "intellect",
        value: 0,
        book: "Core",
        page: "60",
        settings: ["All"],
    },
    {
        name: "Medicine",
        attribute: "intellect",
        value: 0,
        book: "Core",
        page: "61",
        settings: ["All"],
    },
    {
        name: "Melee",
        attribute: "brawn",
        value: 0,
        book: "Core",
        page: "67",
        settings: ["Steampunk", "Weird War", "Modern Day", "Science Fiction", "space opera"],
    },
    {
        name: "Melee (Heavy)",
        attribute: "brawn",
        value: 0,
        book: "Core",
        page: "68",
        settings: ["Fantasy"],
    },
    {
        name: "Melee (Light)",
        attribute: "brawn",
        value: 0,
        book: "Core",
        page: "68",
        settings: ["Fantasy"],
    },
    {
        name: "Negotiation",
        attribute: "presence",
        value: 0,
        book: "Core",
        page: "56",
        settings: ["All"],
    },
    {
        name: "Operating",
        attribute: "intellect",
        value: 0,
        book: "Core",
        page: "62",
        settings: ["All"],
    },
    {
        name: "Perception",
        attribute: "cunning",
        value: 0,
        book: "Core",
        page: "62",
        settings: ["All"],
    },
    {
        name: "Piloting",
        attribute: "agility",
        value: 0,
        book: "Core",
        page: "62",
        settings: ["Weird War", "Modern Day", "Science Fiction", "Space Opera"],
    },
    {
        name: "Primal",
        attribute: "cunning",
        value: 0,
        book: "Core",
        page: "70",
        settings: ["All"],
    },
    {
        name: "Ranged",
        attribute: "agility",
        value: 0,
        book: "Core",
        page: "67",
        settings: ["Fantasy"],
    },
    {
        name: "Ranged (Heavy)",
        attribute: "agility",
        value: 0,
        book: "Core",
        page: "68",
        settings: ["Steampunk", "Weird War", "Modern Day", "Science Fiction", "space opera"],
    },
    {
        name: "Ranged (Light)",
        attribute: "agility",
        value: 0,
        book: "Core",
        page: "68",
        settings: ["Steampunk", "Weird War", "Modern Day", "Science Fiction", "space opera"],
    },
    {
        name: "Resilience",
        attribute: "brawn",
        value: 0,
        book: "Core",
        page: "63",
        settings: ["All"],
    },
    {
        name: "Riding",
        attribute: "agility",
        value: 0,
        book: "Core",
        page: "63",
        settings: ["Fantasy", "Steampunk"],
    },
    {
        name: "Skulduggery",
        attribute: "cunning",
        value: 0,
        book: "Core",
        page: "64",
        settings: ["All"],
    },
    {
        name: "Stealth",
        attribute: "agility",
        value: 0,
        book: "Core",
        page: "64",
        settings: ["All"],
    },
    {
        name: "Streetwise",
        attribute: "cunning",
        value: 0,
        book: "Core",
        page: "65",
        settings: ["All"],
    },
    {
        name: "Survival",
        attribute: "cunning",
        value: 0,
        book: "Core",
        page: "65",
        settings: ["All"],
    },
    {
        name: "Vigilance",
        attribute: "willpower",
        value: 0,
        book: "Core",
        page: "65",
        settings: ["All"],
    }

];

